import { axiosInstance } from '@/lib/axios';
import { TimesheetConfigurationModelRaw } from './types';

type Props = {
  companyId: string
}

export function getTimesheetBasicSettings({ companyId }: Props) {
  return axiosInstance.get<TimesheetConfigurationModelRaw>(`/api/${companyId}/configuration/timesheet`);
}
